import React from "react";
import { Button } from "@repo/ui";

interface NavigationButtonsProps {
  continueLabel: string;
  backLabel: string;
  onContinue: () => void;
  onBack: () => void;
  className?: string;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  continueLabel,
  backLabel,
  onContinue,
  onBack,
  className = "",
}) => {
  return (
    <div className={`flex flex-wrap gap-4 ${className}`}>
      <Button
        label={backLabel}
        onClick={onBack}
        type="secondary"
        className="flex-1 min-w-[140px]"
      />
      <Button
        label={continueLabel}
        onClick={onContinue}
        type="primary"
        className="flex-1 min-w-[140px]"
      />
    </div>
  );
};

export default NavigationButtons;
